var _path, _path2, _path3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

const SvgRss = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 512 512"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M15 120c207.9 0 377 169.1 377 377v15h120v-15a495.2 495.2 0 0 0-146-351A495.2 495.2 0 0 0 15 0H0v120zm15-89.8A467.6 467.6 0 0 1 481.8 482h-60a406.8 406.8 0 0 0-119.4-272.4A405.8 405.8 0 0 0 30 90.3zm0 0"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M212 497v15h120v-15a316 316 0 0 0-93.3-223.7A316 316 0 0 0 15 180H0v120h15c106.8 0 197 90.2 197 197zM30 210.4A287.4 287.4 0 0 1 301.6 482h-60.1a225.5 225.5 0 0 0-66.4-145.1A225.5 225.5 0 0 0 30 270.5zm0 0"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M76 512c41.3 0 76-34.4 76-76 0-41.3-34.4-76-76-76-41.3 0-76 34.4-76 76 0 41.3 34.4 76 76 76zm0-122c25 0 46 21 46 46s-21 46-46 46-46-21-46-46 21-46 46-46zm0 0"
})));

export default SvgRss;